import React from 'react';
import {PAGINATION} from "ubs-framework/v2/common/constant";

// Default API-usage date filters to the current month (mirrors HRMS) so the date range renders as a chip.
const _now = new Date();
const monthStart = new Date(_now.getFullYear(), _now.getMonth(), 1).getTime();
const monthEnd = new Date(_now.getFullYear(), _now.getMonth() + 1, 0, 23, 59, 59, 999).getTime();

const initialState = {
    billingSubscriptions: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: null,
    },
    billingPayments: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: null,
        paymentType: null,
        fromDate: null,
        toDate: null,
        subscriptionId: '',
    },
    billingActivity: {
        category: null,
        limit: 20,
        skip: 0,
    },
    // API Usage Monitor (Aadhaar & PAN) — migrated from HRMS > Reports.
    // Simplified: only date-range + verification type + status (org-structure side-filters dropped).
    verificationHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: monthStart,
        endDate: monthEnd,
        apiType: '',
        status: '',
    },
    usedHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: monthStart,
        endDate: monthEnd,
    },
    creditHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        startDate: monthStart,
        endDate: monthEnd,
        status: null,
    },
    // Wallet Billing (Phase 8) — tenant-facing billing|wallet|client|* tabs
    walletBillingHistory: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        type: null,
        startDate: null,
        endDate: null,
    },
    walletBillingInvoices: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: null,
        startDate: null,
        endDate: null,
        amountMin: null,
        amountMax: null,
    },
    walletBillingReceipts: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        mode: null,
        startDate: null,
        endDate: null,
        amountMin: null,
        amountMax: null,
    },
    walletBillingTaxInvoices: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        status: null,
        startDate: null,
        endDate: null,
        amountMin: null,
        amountMax: null,
    },
    walletBillingTdsClaims: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        status: null,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SET_BILLING_SUBSCRIPTIONS': {
            return {...state, billingSubscriptions: {...state.billingSubscriptions, ...action.payload}};
        }
        case 'SET_BILLING_PAYMENTS': {
            return {...state, billingPayments: {...state.billingPayments, ...action.payload}};
        }
        case 'SET_BILLING_ACTIVITY': {
            return {...state, billingActivity: {...state.billingActivity, ...action.payload}};
        }
        case 'SET_VERIFICATION_HISTORY': {
            return {...state, verificationHistory: {...state.verificationHistory, ...action.payload}};
        }
        case 'SET_USED_HISTORY': {
            return {...state, usedHistory: {...state.usedHistory, ...action.payload}};
        }
        case 'SET_CREDIT_HISTORY': {
            return {...state, creditHistory: {...state.creditHistory, ...action.payload}};
        }
        case 'SET_WALLET_BILLING_HISTORY': {
            return {...state, walletBillingHistory: {...state.walletBillingHistory, ...action.payload}};
        }
        case 'SET_WALLET_BILLING_INVOICES': {
            return {...state, walletBillingInvoices: {...state.walletBillingInvoices, ...action.payload}};
        }
        case 'SET_WALLET_BILLING_RECEIPTS': {
            return {...state, walletBillingReceipts: {...state.walletBillingReceipts, ...action.payload}};
        }
        case 'SET_WALLET_BILLING_TAX_INVOICES': {
            return {...state, walletBillingTaxInvoices: {...state.walletBillingTaxInvoices, ...action.payload}};
        }
        case 'SET_WALLET_BILLING_TDS_CLAIMS': {
            return {...state, walletBillingTdsClaims: {...state.walletBillingTdsClaims, ...action.payload}};
        }
        default: {
            return state;
        }
    }
}
